import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { addAllBasicExtraReducers } from '../../../../utils/action-builder-utils';
import { downloadOfferDocuments } from './offerings-thunks';
import { OfferingDocumentsState } from './offerings-types';

const initialState: OfferingDocumentsState = {
  offerings: [],
  offeringsRequestStatus: 'idle',
};

const offeringDocumentsSlice = createSlice({
  name: 'features/documents/offering',
  initialState: initialState,
  reducers: {
    clearError(state) {
      state.offeringsError = undefined;
      state.offeringsRequestStatus = 'idle';
    },
    markDocumentAsRead(state, data: PayloadAction<{ id: string }>) {
      const offerings = [...state.offerings];
      const offer = offerings
        .flatMap((d) => d.documents)
        .find((item) => item.id === data.payload.id);
      offer.flagIsRead = true;
      state.offerings = offerings;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    addAllBasicExtraReducers(builder, downloadOfferDocuments, 'offerings');
  },
});

export const offeringDocumentsActions = offeringDocumentsSlice.actions;

export default offeringDocumentsSlice.reducer;
